import { FilterItem, SearchFilter } from '../../services/types/services'
import { getAutoAppliedFilters } from './getAutoAppliedFilters'
import { getFiltersById } from './getFiltersById'

export const getSelectedFilters = ({
  initialFilters,
  persistedFilters,
  allFilters,
  useAutoAppliedFilters,
}: {
  initialFilters: SearchFilter[]
  persistedFilters: string[]
  allFilters: FilterItem[]
  useAutoAppliedFilters: boolean
}) => {
  return [
    ...getFiltersById({
      filterIds: [...initialFilters.map(f => f.key), ...persistedFilters],
      allFilters,
    }),
    ...(useAutoAppliedFilters
      ? getAutoAppliedFilters({
          selectedFilterIds: [
            ...initialFilters.map(f => f.key),
            ...persistedFilters,
          ],
          allFilters,
        })
      : []),
  ]
}
